module.exports = __webpack_public_path__ + "img/qshy.3a200ffe.jpg";